import { detectMob, datasetOfDatasetQuery } from '../assets/utils.js'
import frel from '../assets/frel.js'
import Tabs from '../assets/tabs.js'

const tabContainer = '[data-tab-container]'
const tabs = '[data-reveal-tab]'
const activeClass = 'active'
const targetContainer = '[data-tab-content-container]'
const targets = '[data-card-group]'
const targetActiveClass = 'active'

const sliderConfig = {
    slidesPerView: 1.72,
    spaceBetween: 10,
    navigation: {
        nextEl: '[data--rewards-swiper-navigation-right]',
        prevEl: '[data-rewards-swiper-navigation-left]',
    }, pagination: {
        el: '[data-rewards-swiper-pagination]',
        clickable: true,
        type: 'custom',
        renderCustom(_, current, total) {
            return (`
                      ${current}/${total}
                  `)
        }
    },
    breakpoints: {
        750: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        1000: {
            slidesPerView: 4,
            spaceBetween: 20
        }
    }
}

const generateProductImage = (src) => {
    const img = frel('img', { class: 'rewards-redeem_product-image' })
    img.src = src
    return img
}

const generateDetailsOpener = (i) => {
    return frel('button', { class: 'rewards-redeem_product-description reward-toggle-show' + i, onclick: 'toggleDetails(true, ' + i + ');' }, 'Details')
}

const generateDetailsCloser = (i) => {
    return frel('button', { class: 'rewards-redeem_product-closer reward-toggle-hide' + i, onclick: 'toggleDetails(false, ' + i + ');' }, 'Close details')
}

const generateDetailsBody = (description, i) => {
    return frel('p', { class: 'rewards-redeem_product-body reward-toggle-body' + i }, description)
}

const generateProductTitle = (name) => {
    return frel('p', { class: 'rewards-redeem_product-title' }, name)
}

const generateProductPointCost = (costText) => {
    return frel('p', { class: 'rewards-redeem_product-point-cost' }, costText)
}

const generateLoginButton = () => {
    const anchorElement = frel('a', { class: 'rewards-redeem_product-login-button' }, 'login')
    anchorElement.href = '/account/login'
    return anchorElement
}

const generateRedeemButton = (variantId) => {
    const anchorElement = frel('a', { class: 'rewards-redeem_product-redeem-button swell-buy-product-btn' }, 'add to bag')
    anchorElement.dataset.variantId = variantId
    anchorElement.dataset.errorContent = 'Looks like you need more points to redeem this item. Points needed: *|amount|* pts<br>You have: *|point_balance|* pts'
    anchorElement.dataset.successContent = 'Item added to bag.'
    anchorElement.dataset.errorTitle = 'Sorry'
    anchorElement.dataset.successTitle = 'Hooray!'
    anchorElement.dataset.cancelBtnText = 'NEVER MIND'
    anchorElement.dataset.confirmContent = 'Just checking! You currently have *|point_balance|* points available. This product costs *|amount|* points to redeem.'
    return anchorElement
}

const generateProductCardElement = () => {
    return frel('div', { class: 'rewards-redeem_product-card swiper-slide' })
}

const generateProductCardInnerWrapper = () => {
    return frel('div', { class: 'rewards-redeem_product-card-inner-wrapper' })
}

const loggedInCheck = () => {
    const value = datasetOfDatasetQuery('logged-in-state')
    return value === 'true'
}

// getCart function moved to global.js - using window.getCart() instead

// Main class
class RewardsRedeem extends HTMLElement {
    constructor() {
        super()
        console.log('[RewardsRedeem] Constructor called');
        this.productCards = []
        this.swiperInstance = {}
        this.init()
    }

    query(selector) {
        return this.querySelector(selector)
    }

    inject(selector, element) {
        const container = this.query(selector)
        if (container) {
            container.appendChild(element)
        }
    }



    filterDisplayByGroup(group) {
        console.log('[RewardsRedeem] filterDisplayByGroup called:', group);
        console.log('[RewardsRedeem] productCards count:', this.productCards.length);
        console.log('[RewardsRedeem] redemptionProductsSorted:', this.redemptionProductsSorted);
        
        if (group === 'fiveThousand') {
            // Replace with grid layout for 5000 points
            const fiveThousandProducts = this.redemptionProductsSorted?.fiveThousand || []
            console.log('[RewardsRedeem] Showing grid layout for fiveThousand, products:', fiveThousandProducts.length);
            this.showGridLayout(fiveThousandProducts)
            return
        }
        
        // Restore carousel if coming from 5000 tab
        this.restoreCarouselLayout()
        
        let visibleCount = 0;
        let hiddenCount = 0;
        
        this.productCards.forEach((productCard, index) => {
            const thisCardGroup = productCard.dataset?.cardGroup
            const shouldShow = thisCardGroup === group;
            
            if (shouldShow) {
                productCard.style.display = 'flex'
                visibleCount++;
            } else {
                productCard.style.display = 'none'
                hiddenCount++;
            }
            
            if (index < 3) { // Log first 3 for debugging
                console.log(`[RewardsRedeem] Product card ${index}:`, {
                    group: thisCardGroup,
                    targetGroup: group,
                    matches: shouldShow,
                    display: productCard.style.display,
                    computedDisplay: window.getComputedStyle(productCard).display
                });
            }
        });
        
        console.log('[RewardsRedeem] filterDisplayByGroup complete:', {
            group,
            visibleCount,
            hiddenCount,
            totalCards: this.productCards.length
        });
    }

    showGridLayout(products) {
        const container = this.query('[data-rewards-redeem-slider]')
        if (!container) return

        // Save original carousel content and classes
        if (!this.originalCarouselContent) {
            this.originalCarouselContent = container.innerHTML
            this.originalCarouselClasses = container.className
        }

        // Grid CSS is now included in the main carousel CSS file

        // Create grid HTML structure - exact copy from rewards-redeem-grid
        let gridHTML = ''
        
        if (products.length === 0) {
            gridHTML = `
                <div class="rewards-redeem-empty">
                    <p class="rewards-redeem-empty-header">There are no rewards for this point level at this time.</p>
                    <p class="rewards-redeem-empty-text">We have new rewards every month so make sure to check back soon.</p>
                </div>
            `
        } else {
            products.forEach((product, index) => {
                const { name, appliesToId, costText, description, backgroundImageUrl } = product || {}
                const isReverse = index % 2 === 1
                
                // Get eyebrow text from metaobject mapping, fallback to costText
                const eyebrowText = (window.rewardsEyebrowMapping && window.rewardsEyebrowMapping[appliesToId]) || costText;
                
                gridHTML += `
                    <div class="Rewards-redeem-grid-content${isReverse ? ' reverse' : ''}">
                        <img class="Rewards-redeem-grid-content--image" src="${backgroundImageUrl || ''}" width="auto" height="auto">
                        <div class="Rewards-redeem-grid-content--text">
                            ${eyebrowText ? `<p class="Rewards-redeem-grid-content--text-eyebrow">${eyebrowText}</p>` : ''}
                            ${name ? `<p class="Rewards-redeem-grid-content--text-heading">${name}</p>` : ''}
                            ${description ? `<div class="Rewards-redeem-grid-content--text-text">${description}</div>` : ''}
                            ${costText ? `<p class="Rewards-redeem-grid-content--text-points">${costText}</p>` : ''}
                            ${appliesToId ? `
                                <a href="#" class="Rewards-redeem-grid-content--text-link swell-buy-product-btn" 
                                   data-variant-id="${appliesToId}"
                                   data-error-content="Looks like you need more points to redeem this item. Points needed: *|amount|* pts<br>You have: *|point_balance|* pts"
                                   data-success-content="Item added to bag."
                                   data-error-title="Sorry"
                                   data-success-title="Hooray!"
                                   data-cancel-btn-text="NEVER MIND"
                                   data-confirm-content="Just checking! You currently have *|point_balance|* points available. This product costs *|amount|* points to redeem."
                                   style="cursor: pointer;">
                                   add to bag
                                </a>
                            ` : ''}
                        </div>
                    </div>
                `
            })
        }
        
        // Replace carousel with grid - remove all carousel classes
        container.innerHTML = gridHTML
        container.className = 'Rewards-redeem-grid'
        
        // Re-initialize Swell buttons with a small delay to ensure DOM is ready
        setTimeout(() => {
            if (typeof spapi !== 'undefined' && spapi) {
                spapi.setupBuyProductWithPointsHelper()
            }
            if (typeof swellAPI !== 'undefined' && swellAPI) {
                swellAPI.refreshEmbeds()
            }
            
            // Also manually attach click event handlers as fallback
            const buttons = container.querySelectorAll('.swell-buy-product-btn')
            buttons.forEach(button => {
                button.addEventListener('click', function(e) {
                    e.preventDefault()
                    // Trigger Swell's redemption flow
                    if (typeof spapi !== 'undefined' && spapi && spapi.buyProductWithPoints) {
                        const variantId = this.getAttribute('data-variant-id')
                        if (variantId) {
                            spapi.buyProductWithPoints(variantId)
                        }
                    }
                })
            })
        }, 100)
    }

    restoreCarouselLayout() {
        const container = this.query('[data-rewards-redeem-slider]')
        if (!container || !this.originalCarouselContent) return

        container.innerHTML = this.originalCarouselContent
        container.className = this.originalCarouselClasses || 'rewards-redeem_tab-slide-container swiper'
        
        // Repopulate the productCards array with the restored DOM elements
        this.productCards = Array.from(this.querySelectorAll('.rewards-redeem_product-card'))
        
        // Reinitialize Swell functionality for the restored buttons
        setTimeout(() => {
            this.initProductCards()
        }, 100)
    }

    initProductCards() {
        if (spapi) {
            spapi.setupBuyProductWithPointsHelper()
        }
        swellAPI.refreshEmbeds()
    }

    initRedeemSucess() {
        window.onBeforeProductRedemption = async (opts, redemptionOption, pointBalance, cb) => {
            console.log('onBeforeProductRedemption', opts, redemptionOption, pointBalance, cb)
            const cart = await window.getCart()
            if (cart.items_subtotal_price < 1) {
                spapi.$.confirm({
                    title: "Oops!",
                  content: "You can only redeem points for a free product when making a purchase.",
                  type: "red",
                  typeAnimated: true,
                  useBootstrap: false,
                  boxWidth: "400px",
                  buttons: {
                    ok: {
                      text: "Ok",
                      action: function () {
                      }
                    }
                  }
                });
            } else {
                cb()
            }
        }

        document.addEventListener('swell:redemption', redemption => {
        
        })
    }

    initTabButtons() {
        console.log('[RewardsRedeem] initTabButtons called');
        const tabsInstance = new Tabs({
            tabContainer,
            tabs,
            activeClass,
            targetContainer,
            targets,
            targetActiveClass,
            funcSettings: {
                beforeTargetClassAdded: (_, tab) => {
                    console.log('[RewardsRedeem] Tab clicked in Tabs class:', tab);
                    const group = tab.dataset?.targetGroup
                    console.log('[RewardsRedeem] Target group:', group);
                    
                    const sliderControls = document.querySelector('[data-rewards-swiper-pagination]')
                    console.log('[RewardsRedeem] Slider controls:', sliderControls);
                    
                    this.destroySlider()
                    console.log('[RewardsRedeem] Slider destroyed');
                    
                    this.filterDisplayByGroup(group)
                    console.log('[RewardsRedeem] filterDisplayByGroup called for:', group);
                    
                    // Only initialize slider if we're not in grid mode
                    const sliderElement = document.querySelector('[data-rewards-redeem-slider]')
                    console.log('[RewardsRedeem] Slider element:', sliderElement, sliderElement?.classList.contains('swiper'));
                    if (sliderElement && sliderElement.classList.contains('swiper')) {
                        this.initSlider()
                        console.log('[RewardsRedeem] Slider initialized');
                    }
                    
                    if (sliderControls) {
                        sliderControls.style.display = 'none'
                        const visibleProductCards = document.querySelectorAll('[data-card-group]:not([style*="display: none"])')
                        console.log('[RewardsRedeem] Visible product cards:', visibleProductCards.length);
                        if (detectMob() && visibleProductCards.length > 1) {
                            sliderControls.style.display = 'flex'
                            console.log('[RewardsRedeem] Slider controls shown (mobile)');
                        } else if (visibleProductCards.length > 4) {
                            sliderControls.style.display = 'flex'
                            console.log('[RewardsRedeem] Slider controls shown (desktop)');
                        }
                    }
                    // return true to stop the target class from being added
                    console.log('[RewardsRedeem] beforeTargetClassAdded returning true');
                    return true
                }
            }
        })
        console.log('[RewardsRedeem] Tabs instance created:', tabsInstance);
    }

    async renderProductCard(data, group, i) {
        const { name, appliesToId, costText, description, backgroundImageUrl } = data || {}
        const nameElement = generateProductTitle(name)
        const pointCostElement = generateProductPointCost(costText)
        const imageElement = generateProductImage(backgroundImageUrl)
        const redeemButtonElement = generateRedeemButton(appliesToId)
        const descriptionOpener = generateDetailsOpener(i)
        const descriptionCloser = generateDetailsCloser(i)
        const descriptionBody = generateDetailsBody(description, i)
        const loginButtonElement = generateLoginButton()
        const productCardElelment = generateProductCardElement()
        const productCardInnerWrapper = generateProductCardInnerWrapper()
        productCardInnerWrapper.appendChild(imageElement)
        productCardInnerWrapper.appendChild(nameElement)
        productCardInnerWrapper.appendChild(descriptionOpener)
        productCardInnerWrapper.appendChild(descriptionBody)
        productCardInnerWrapper.appendChild(descriptionCloser)
        productCardInnerWrapper.appendChild(pointCostElement)
        if (loggedInCheck()) {
            productCardInnerWrapper.appendChild(redeemButtonElement)
        } else {
            productCardInnerWrapper.appendChild(loginButtonElement)
        }
        productCardElelment.appendChild(productCardInnerWrapper)
        productCardElelment.dataset.cardGroup = group
        
        this.inject('[data-card-group-container]', productCardElelment)
        this.productCards.push(productCardElelment)
    }

    renderProductCards() {
        console.log('[RewardsRedeem] renderProductCards called');
        const container = this.query('[data-card-group-container]')
        console.log('[RewardsRedeem] Container found:', container);
        
        // Clear existing product cards if any
        if (container) {
            console.log('[RewardsRedeem] Clearing container, current children:', container.children.length);
            container.innerHTML = ''
        } else {
            console.error('[RewardsRedeem] Container [data-card-group-container] not found!');
        }
        this.productCards = []
        
        console.log('[RewardsRedeem] redemptionProductsSorted:', this.redemptionProductsSorted);
        var i = 0;
        Object.keys(this.redemptionProductsSorted).forEach(async (key) => {
            const pointProductsArray = this.redemptionProductsSorted[key]
            console.log(`[RewardsRedeem] Rendering products for group ${key}:`, pointProductsArray.length);
            pointProductsArray.forEach(pointProduct => {
                i = i + 1;
                this.renderProductCard(pointProduct, key, i);
            })
            this.filterDisplayByGroup('twoHundred')
        })
        
        console.log('[RewardsRedeem] renderProductCards complete, total cards:', this.productCards.length);
    }

    initSlider() {
        // Only initialize if we're in carousel mode (not grid mode for 5000 points)
        const sliderElement = document.querySelector('[data-rewards-redeem-slider]')
        if (window.innerWidth <= 750 && sliderElement && sliderElement.classList.contains('swiper')) {
            this.swiperInstance = new Swiper('[data-rewards-redeem-slider]', sliderConfig);
        }
    }

    destroySlider() {
        if (this.swiperInstance && this.swiperInstance.destroy) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    }

    handleResize() {
        if (window.innerWidth > 750) {
            this.destroySlider();
        } else {
            this.initSlider();
        }
    }

    swellVariablesInit() {
        console.log('[RewardsRedeem] swellVariablesInit called');
        console.log('[RewardsRedeem] swellAPI available:', typeof swellAPI !== 'undefined');
        
        this.activeRedemptionOptions = swellAPI.getActiveRedemptionOptions()
        console.log('[RewardsRedeem] Active redemption options:', this.activeRedemptionOptions?.length || 0);
        
        this.redemptionProducts = this.activeRedemptionOptions.filter(redemptionOption => {
            return redemptionOption.discountType === 'product'
        })
        console.log('[RewardsRedeem] Redemption products (product type):', this.redemptionProducts.length);
        
        this.twoHundredPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 200
        })
        this.fiveHundredPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 500
        })
        this.oneThousandPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 1000
        })
        this.fiveThousandPointRedemptionPoints = this.redemptionProducts.filter(redemptionProduct => {
            return redemptionProduct.costInPoints === 5000
        })
        
        console.log('[RewardsRedeem] Products by point level:', {
            twoHundred: this.twoHundredPointRedemptionPoints.length,
            fiveHundred: this.fiveHundredPointRedemptionPoints.length,
            oneThousand: this.oneThousandPointRedemptionPoints.length,
            fiveThousand: this.fiveThousandPointRedemptionPoints.length
        });
        
        this.redemptionProductsSorted = {
            twoHundred: this.twoHundredPointRedemptionPoints,
            fiveHundred: this.fiveHundredPointRedemptionPoints,
            oneThousand: this.oneThousandPointRedemptionPoints,
            fiveThousand: this.fiveThousandPointRedemptionPoints
        }
        
        console.log('[RewardsRedeem] redemptionProductsSorted initialized:', this.redemptionProductsSorted);
    }

    initListeners() {
        console.log('[RewardsRedeem] initListeners called');
        window.addEventListener('resize', this.handleResize.bind(this));
        
        console.log('[RewardsRedeem] Waiting for swell:setup event...');
        document.addEventListener('swell:setup', () => {
            console.log('[RewardsRedeem] swell:setup event fired!');
            try {
                this.swellVariablesInit();
                this.renderProductCards();
                this.handleResize(); 
                this.initTabButtons();
                this.initProductCards();
                this.initRedeemSucess();
                console.log('[RewardsRedeem] All initialization complete');
            } catch (error) {
                console.error('[RewardsRedeem] Error during swell:setup initialization:', error);
            }
        });
        
        // Also check if swell is already set up
        if (typeof swellAPI !== 'undefined' && swellAPI && swellAPI.getActiveRedemptionOptions) {
            console.log('[RewardsRedeem] Swell API already available, checking if setup is needed...');
            setTimeout(() => {
                const options = swellAPI.getActiveRedemptionOptions();
                if (options && options.length > 0) {
                    console.log('[RewardsRedeem] Swell already has redemption options, triggering setup');
                    document.dispatchEvent(new Event('swell:setup'));
                } else {
                    console.log('[RewardsRedeem] Swell API available but no redemption options yet');
                }
            }, 1000);
        }
    }

    init() {
        console.log('[RewardsRedeem] init called');
        this.initListeners()
    }
}

customElements.define('rewards-redeem', RewardsRedeem)